import { FC, useEffect, useState } from "react"

interface PdfViewerProps {
  /** Blob del archivo PDF */
  pdfBlob: Blob
}

/**
 * Componente para visualizar PDFs de forma nativa en el navegador.
 * Acepta un Blob como entrada y lo convierte en una URL para visualización.
 *
 * @example
 * ```tsx
 * <PdfViewer
 *   pdfBlob={myPdfBlob}
 * />
 * ```
 */
export const PdfViewer: FC<PdfViewerProps> = ({ pdfBlob }) => {
  const [pdfUrl, setPdfUrl] = useState<string>("")

  useEffect(() => {
    const pdfBlobWithType = new Blob([pdfBlob], { type: "application/pdf" })
    const url = URL.createObjectURL(pdfBlobWithType)
    setPdfUrl(url)

    return () => {
      URL.revokeObjectURL(url)
    }
  }, [pdfBlob])

  if (!pdfUrl) {
    return null
  }

  return (
    <div className='tw-flex tw-h-full tw-col-span-2'>
      <embed
        src={pdfUrl}
        type='application/pdf'
        className='tw-w-full tw-h-full'
        style={{
          border: "none",
          display: "block",
        }}
      />
    </div>
  )
}
